/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum AppointmentMode {
  PHONE = "PHONE",
  VIDEO = "VIDEO",
}

export enum AppointmentStatus {
  CANCELLED = "CANCELLED",
  COMPLETED = "COMPLETED",
  CONFIRMED = "CONFIRMED",
}

export enum AuthTypeEnum {
  AUTH0_SSO = "AUTH0_SSO",
  LEGACY_CREDENTIALS = "LEGACY_CREDENTIALS",
  MIXED_MODE = "MIXED_MODE",
}

export enum ConsentType {
  PIPL_CROSS_BORDER_TRANSFER = "PIPL_CROSS_BORDER_TRANSFER",
  PIPL_PRIVACY_POLICY = "PIPL_PRIVACY_POLICY",
  PIPL_SENSITIVE_DATA = "PIPL_SENSITIVE_DATA",
  PIPL_THIRD_PARTY_SHARING = "PIPL_THIRD_PARTY_SHARING",
}

export enum ContentProgress {
  COMPLETED = "COMPLETED",
  IN_PROGRESS = "IN_PROGRESS",
  NOT_STARTED = "NOT_STARTED",
}

export enum CourseStatus {
  ALL = "ALL",
  COMPLETED = "COMPLETED",
  IN_PROGRESS = "IN_PROGRESS",
}

export enum DashboardKey {
  EAP = "EAP",
  NOVA = "NOVA",
  PLATFORM = "PLATFORM",
  SUMMARY = "SUMMARY",
  THERAPY_AND_COACHING = "THERAPY_AND_COACHING",
}

export enum EventName {
  AI_COACH_CHATBOT_MESSAGE_SENT = "AI_COACH_CHATBOT_MESSAGE_SENT",
  APP_LOGGED_IN_FOCUSED = "APP_LOGGED_IN_FOCUSED",
  CHATBOT_MESSAGE_DISLIKED = "CHATBOT_MESSAGE_DISLIKED",
  CHATBOT_MESSAGE_LIKED = "CHATBOT_MESSAGE_LIKED",
  COLLEAGUE_INVITE_CTA_CLICKED = "COLLEAGUE_INVITE_CTA_CLICKED",
  CONTENT_DISLIKED = "CONTENT_DISLIKED",
  CONTENT_DOWNLOADED = "CONTENT_DOWNLOADED",
  CONTENT_LIKED = "CONTENT_LIKED",
  CONTENT_SHARED = "CONTENT_SHARED",
  HELP_EAP_CONTACT_SERVICE_CLICKED = "HELP_EAP_CONTACT_SERVICE_CLICKED",
  HELP_RESOURCE_CLICKED = "HELP_RESOURCE_CLICKED",
  INTEGRATION_CARD_CLICKED = "INTEGRATION_CARD_CLICKED",
  INTEGRATION_REGISTERED_INTEREST = "INTEGRATION_REGISTERED_INTEREST",
  INVITE_LOVED_ONE_CTA_CLICKED = "INVITE_LOVED_ONE_CTA_CLICKED",
  NAVIGATED_TO_PAGE = "NAVIGATED_TO_PAGE",
  SEARCH_RESULT_SELECTED = "SEARCH_RESULT_SELECTED",
  SETTINGS_IN_APP_LANGUAGE_CHANGED = "SETTINGS_IN_APP_LANGUAGE_CHANGED",
  SHARED_CONTENT_VIEWED = "SHARED_CONTENT_VIEWED",
  TALK_BOOKING_FLOW_COMPLETED = "TALK_BOOKING_FLOW_COMPLETED",
  WELCOME_MODAL_CTA_CLICKED = "WELCOME_MODAL_CTA_CLICKED",
  WELCOME_MODAL_DISMISSED = "WELCOME_MODAL_DISMISSED",
  WELCOME_MODAL_OPTION_CLICKED = "WELCOME_MODAL_OPTION_CLICKED",
  WELCOME_MODAL_SHOWN = "WELCOME_MODAL_SHOWN",
  WELLBEING_TRACKER_STARTED = "WELLBEING_TRACKER_STARTED",
}

export enum FeedbackCategory {
  NEGATIVE = "NEGATIVE",
  NEUTRAL = "NEUTRAL",
  POSITIVE = "POSITIVE",
}

export enum FilterContext {
  MANAGER_REPORTING = "MANAGER_REPORTING",
}

export enum FindTeamSourceType {
  SIGNIN = "SIGNIN",
  SIGNUP = "SIGNUP",
}

export enum IdentifierKeys {
  EMPLOYEE_ID = "EMPLOYEE_ID",
}

export enum Mood {
  HAPPY = "HAPPY",
  OK = "OK",
  SAD = "SAD",
  SLIGHTLY_HAPPY = "SLIGHTLY_HAPPY",
  SLIGHTLY_SAD = "SLIGHTLY_SAD",
  VERY_HAPPY = "VERY_HAPPY",
  VERY_SAD = "VERY_SAD",
}

export enum MutationStatusCode {
  DUPLICATE_ENTRY = "DUPLICATE_ENTRY",
  ERROR = "ERROR",
  INVALID = "INVALID",
  SUCCESS = "SUCCESS",
}

/**
 * Defines the list of support options to show during onboarding
 */
export enum OnboardingSupportOption {
  CONTENT = "CONTENT",
  IMMEDIATE_SUPPORT = "IMMEDIATE_SUPPORT",
  MANAGERS = "MANAGERS",
  NOVA = "NOVA",
  PRACTICAL_SUPPORT = "PRACTICAL_SUPPORT",
  THERAPY_COACHING = "THERAPY_COACHING",
}

export enum OrganisationAliasSearchStatusCode {
  ORG_ALIAS_NOT_FOUND = "ORG_ALIAS_NOT_FOUND",
  SUCCESS = "SUCCESS",
}

export enum RegistrationMethod {
  CLOSED = "CLOSED",
  NONE = "NONE",
  OPEN = "OPEN",
  VOUCHER = "VOUCHER",
}

export enum RegistrationMethodValue {
  CLOSED_EMPLOYEE_ID = "CLOSED_EMPLOYEE_ID",
  OPEN_EMAIL = "OPEN_EMAIL",
}

export enum RegistrationSessionValidationResult {
  INVALID_OR_EXPIRED = "INVALID_OR_EXPIRED",
  VALID = "VALID",
}

export enum TimePeriod {
  ALL_TIME = "ALL_TIME",
  LAST_12_WEEKS = "LAST_12_WEEKS",
  LAST_30_DAYS = "LAST_30_DAYS",
  LAST_6_MONTHS = "LAST_6_MONTHS",
}

export enum TokenInvalidMessage {
  INVITEES_LIMIT_REACHED = "INVITEES_LIMIT_REACHED",
  INVITER_ACCOUNT_DELETED = "INVITER_ACCOUNT_DELETED",
  TOKEN_INVALID = "TOKEN_INVALID",
}

export enum ToolActivityEvent {
  TOOL_COMPLETED = "TOOL_COMPLETED",
  TOOL_PLAYED = "TOOL_PLAYED",
}

export enum UserAuthMethod {
  CREDENTIALS = "CREDENTIALS",
  SSO = "SSO",
}

export enum UserFeature {
  DEPARTMENT_LOCATION_SELECTION = "DEPARTMENT_LOCATION_SELECTION",
  HELP = "HELP",
  LINE_MANAGER_CONTENT = "LINE_MANAGER_CONTENT",
  NOVA = "NOVA",
  TALK = "TALK",
}

export enum VerifyUserForRegistrationByMembershipIdOutcome {
  INVALID_LINK = "INVALID_LINK",
  SIGN_IN_LINK_SENT = "SIGN_IN_LINK_SENT",
  VERIFICATION_EMAIL_SENT = "VERIFICATION_EMAIL_SENT",
}

/**
 * What the member did with the onboarding welcome modal. Absent when their
 * account was created before the modal shipped, so they are never shown it.
 */
export enum WelcomeStatus {
  completed = "completed",
  dismissed = "dismissed",
  pending = "pending",
}

export enum WellbeingTrackerBanding {
  High = "High",
  Low = "Low",
  LowMid = "LowMid",
  Mid = "Mid",
  MidHigh = "MidHigh",
}

export enum WellbeingTrackerBands {
  High = "High",
  Low = "Low",
  Mid = "Mid",
}

export interface BookingFilters {
  expertises?: string[] | null;
  appointmentMode: AppointmentMode;
  languages: string[];
  timeZone: string;
}

export interface ChatbotMessageFeedbackInput {
  messageId: string;
  conversationId: string;
}

export interface ConfirmUserAccountInput {
  registrationToken: any;
  isMobile: boolean;
  userData: UserAccountData;
  consentGiven: UserConsentGiven;
}

export interface CourseImpactQuestionnaireResponse {
  questionId: string;
  responseId: string;
}

export interface CreateCheckInInput {
  mood: string;
  feelingIds?: (number | null)[] | null;
  note?: string | null;
  clientSentAtUtcTimestamp?: string | null;
}

export interface CreateInvitedUserInput {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  subdomain: string;
  timezone: string;
  invitationToken: string;
  explicitEEADataStorageConsentGiven?: boolean | null;
  explicitPrivacyConsentGiven: boolean;
  explicitHealthDataConsentGiven?: boolean | null;
  marketingOptIn: boolean;
  piplPrivacyPolicyConsentGiven?: boolean | null;
  piplSensitiveDataConsentGiven?: boolean | null;
  piplThirdPartySharingConsentGiven?: boolean | null;
  piplCrossBorderTransferConsentGiven?: boolean | null;
}

/**
 * The days and hours a user missed from work, submitted as two separate
 * figures. The client does not combine them and the server does not store a
 * total — the Data Platform calculates it.
 */
export interface DaysAndHoursAnswerInput {
  days: number;
  hours: number;
}

export interface ExploreSearchInput {
  after?: string | null;
  first?: number | null;
  searchTerm: string;
  searchSessionId?: string | null;
  clientSentAtUtcTimestamp?: string | null;
}

export interface GetUserCoursesInput {
  first?: number | null;
  after?: string | null;
  status?: CourseStatus | null;
}

export interface Identifier {
  key: IdentifierKeys;
  value: any;
}

export interface IndexRecommendationInput {
  band: WellbeingTrackerBanding;
  category: string;
}

export interface IsValidInvitationTokenInput {
  token: string;
}

export interface LogEventInput {
  eventName: EventName;
  eventProperties?: any | null;
  brazeProperties?: any | null;
}

export interface MergeTeamsBrazeProfilesInput {
  teamsUserId: string;
}

export interface NotificationPreferencesChoicesInput {
  communityParticipation?: boolean | null;
  upcomingEvents?: boolean | null;
  productUpdates?: boolean | null;
  wellbeingReminders?: boolean | null;
}

export interface OrganisationAliasSearchInput {
  searchTerm: string;
}

export interface OrganisationInput {
  id: any;
}

export interface OrganisationInsightsFiltersInput {
  context: FilterContext;
  startDate?: any | null;
  endDate: any;
  timePeriod?: TimePeriod | null;
}

export interface OrganisationRegistrationMethod {
  type: RegistrationMethodValue;
}

export interface OrganisationsByMsTenantIdsInput {
  msTenantIds: string[];
}

export interface QuestionnaireQuestionResponse {
  questionId: string;
  responseId: string;
}

export interface RecordCourseImpactQuestionnaireInput {
  courseId: string;
  responses: CourseImpactQuestionnaireResponse[];
  version: string;
  clientSentAtUtcTimestamp?: string | null;
}

export interface RecordSeriesQuestionnaireResponsesInput {
  responses: SeriesQuestionResponse[];
  isInitialQuestionnaire: boolean;
  seriesId: string;
  clientSentAtUtcTimestamp?: string | null;
}

export interface RecordSeriesSegmentCompletedInput {
  segmentId: string;
  sessionId: string;
  seriesId: string;
  secondsToCompleteSegment: number;
  exploreCategoryId?: string | null;
  clientSentAtUtcTimestamp?: string | null;
}

export interface SaveUnmindIndexResponsesInput {
  questionnaireVersion: number;
  responses: QuestionnaireQuestionResponse[];
  clientSentAtUtcTimestamp?: string | null;
}

export interface SaveWellbeingMeasureResponsesInput {
  questionnaireId: string;
  startedAt: any;
  completedAt: any;
  entryPoint: string;
  answers: WellbeingMeasureAnswerInput[];
}

export interface SeriesQuestionResponse {
  seriesQuestionId: string;
  answer: number;
}

export interface SetUserSelectedLocationInput {
  countryCode: string;
}

export interface SubmitFeedbackInput {
  source: string;
  category: FeedbackCategory;
  feedback: string;
  consentForContact: boolean;
  contentId?: string | null;
  contentSlug?: string | null;
  chatbotMessageFeedback?: ChatbotMessageFeedbackInput | null;
  tags?: string[] | null;
}

export interface UpdateNotificationPreferencesInput {
  teamsNotificationPrefs?: NotificationPreferencesChoicesInput | null;
  emailNotificationPrefs?: NotificationPreferencesChoicesInput | null;
}

export interface UpdateUserInput {
  country?: string | null;
  departmentId?: string | null;
  emailAddress?: string | null;
  explicitEEADataStorageConsentGiven?: boolean | null;
  explicitPrivacyConsentGiven?: boolean | null;
  explicitHealthDataConsentGiven?: boolean | null;
  firstName?: string | null;
  lastName?: string | null;
  locationId?: string | null;
  marketingOptIn?: boolean | null;
  onboardingStatus?: string | null;
  piplPrivacyPolicyConsentGiven?: boolean | null;
  piplSensitiveDataConsentGiven?: boolean | null;
  piplThirdPartySharingConsentGiven?: boolean | null;
  piplCrossBorderTransferConsentGiven?: boolean | null;
  state?: string | null;
  timezone?: string | null;
  welcomeStatus?: WelcomeStatus | null;
  userLocale?: string | null;
  userLocaleOriginal?: string | null;
  praiseDirectory?: boolean | null;
}

export interface UpdateUserPasswordInput {
  currentPassword: string;
  newPassword: string;
}

export interface UserAccountData {
  firstName: any;
  lastName: any;
  password: any;
  departmentId?: any | null;
  locationId?: any | null;
}

export interface UserConsentGiven {
  marketing: boolean;
  explicitPrivacy: boolean;
  explicitEEADataStorage: boolean;
  explicitHealthData: boolean;
  piplPrivacyPolicyConsentGiven?: boolean | null;
  piplSensitiveDataConsentGiven?: boolean | null;
  piplThirdPartySharingConsentGiven?: boolean | null;
  piplCrossBorderTransferConsentGiven?: boolean | null;
}

export interface UserInput {
  email: any;
  identifiers?: (Identifier | null)[] | null;
}

export interface ValidateRegistrationSessionInput {
  registrationToken: any;
}

export interface VerifyUserForRegistrationByMembershipIdInput {
  membershipId: any;
}

export interface VerifyUserForRegistrationInput {
  registrationMethod: OrganisationRegistrationMethod;
  organisation: OrganisationInput;
  user: UserInput;
}

export interface WellbeingMeasureAnswerInput {
  questionId: string;
  answer: WellbeingMeasureAnswerValueInput;
}

/**
 * The value of a single answer. Exactly one field must be set: `numeric` for
 * the six numeric questions, `daysAndHours` for Absenteeism, which is the
 * only question whose answer has two parts.
 */
export interface WellbeingMeasureAnswerValueInput {
  numeric?: number | null;
  daysAndHours?: DaysAndHoursAnswerInput | null;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
